import React from "react";
import Header from "../components/header";
import Footer from "../components/Footer";

const CancellationPolicy = () => (
  <>
    <Header currentPage="cancellation" />
    <div
      style={{
        background: "#23272b",
        color: "#f5f5f5",
        textAlign: "left",
        minHeight: "100vh",
        padding: "48px 0 32px 0",
        marginTop: "80px", // Add margin top for spacing below header
      }}
    >
      <div style={{ paddingLeft: "32px", paddingRight: "16px", maxWidth: "100%" }}>
        <h1 className="mb-4">Cancellation & Refund Policy</h1>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            All advance payments made at the time of booking are strictly
            non-refundable and non-cancellable, under any circumstances.
          </div>
        </div>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            Before completing the payment, customers are required to tick a
            mandatory checkbox confirming acceptance of this policy and our Terms &
            Conditions.
          </div>
        </div>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            Proceeding with the payment indicates full acceptance of this policy.
          </div>
        </div>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            If the customer cancels the booking or chooses not to avail the service,
            the advance amount will be forfeited and will not be refunded.
          </div>
        </div>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            In case of a no-show, you will be charged the total price of the
            reservation.
          </div>
        </div>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            In the rare event that the service cannot be delivered due to our fault
            (e.g., double booking, service unavailability), the advance will be
            either: Adjusted against a future booking, OR Refunded at our
            discretion.
          </div>
        </div>

        <h1 className="mb-4 mt-5">Payment Policy</h1>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>50% of the total booking amount to be paid at the time of booking.</div>
        </div>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            The remaining 50% of the total booking amount is to be paid, 7 days
            before arrival.
          </div>
        </div>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            A Refundable Security Deposit is to be given to the Property
            Manager/Caretaker upon check-in via Cash, Bank Transfer, or UPI.
          </div>
        </div>
        <div className="policy-item mb-3">
          <div className="policy-icon">→</div>
          <div>
            The security deposit will be returned at the time of check-out, subject
            to no spillages, damages and/or breakages, etc, caused by one or more
            guests between check-in and check-out, an appropriate amount will be
            deducted from the total security deposit.
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <style>{`
      body {
        background: #181a1b !important;
      }
      .policy-item .policy-icon {
        color: #3a86ff;
        font-weight: bold;
        margin-right: 10px;
        display: inline-block;
        min-width: 18px;
      }
      .policy-item {
        display: flex;
        align-items: flex-start;
        gap: 8px;
      }
      @media (max-width: 900px) {
        div[style*="padding-left"] {
          padding-left: 10px !important;
          padding-right: 10px !important;
        }
      }
    `}</style>
  </>
);

export default CancellationPolicy;
